import Service from "./Service";
import { WorkActiveEntity, WorkPropEntity, WorkRoleEntity, WorkTaskEntity, WorkTaskModel } from "../model/Work";
import { PageList } from "@/model/system";
class workService extends Service {
  getWorkTasks(data: WorkTaskEntity) {
    return this.post<WorkTaskEntity>(`/WorkTask/GetWorkTasks`, data);
  }
  TaskResolve(id: string, options: WorkTaskEntity) {
    return this.get<WorkTaskEntity>(`/WorkTask/Resolve/${id}`, options);
  }
  TaskReject(id: string, options: WorkTaskEntity) {
    return this.get<WorkTaskEntity>(`/WorkTask/Reject/${id}`, options);
  }
  List(data: WorkTaskEntity) {
    return this.post<PageList<WorkTaskEntity>>(`/WorkTask/List`, data);
  }
}
export default new workService("work");
